/* =============================
    CUSTOM SCRIPTS
   ============================= */

/* -----------------------------
    ADA MODIFICATIONS
   ----------------------------- */
document.addEventListener("DOMContentLoaded", function() {
  function findHeaderWithText(text, doc) {
    const headers = doc.querySelectorAll('h4.rp-messenger-widget-content-header.rp-widget-header.rp-align-items-space-between');

    for (let i = 0; i < headers.length; i++) {
      if (headers[i].textContent === text) {
        return headers[i];
      }
    }

    return null;
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === "childList") {
        const iframe = document.getElementById('richpanel_messenger_iframe');
        if (iframe) {
          const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
          const logo = iframeDocument.querySelector('.messenger-brand-icon');
          if (logo) {
            logo.setAttribute('alt', 'Ipanema Chat Logo');
          }
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// Error banner focus
  document.addEventListener('DOMContentLoaded', (event) => {
    const errorBanner = document.getElementById('error-banner');
    if (errorBanner) {
      errorBanner.setAttribute('tabindex','-1');
      errorBanner.focus();
    }
  });

// Mega Menu Accessible through keyboard
const megaLinks = document.querySelectorAll("nav details[is='dropdown-disclosure']");

megaLinks.forEach((ml, i) => {
  ml.addEventListener("keydown", e => {
    if(e.keyCode === 40 || e.keyCode === 39) {
      const otherMegaLinks = Array.from(megaLinks).filter((_, index) => index !== i);
      otherMegaLinks.forEach(oml => {
        oml.removeAttribute("open")
        const dropDown = oml.querySelector(".dropdown-menu");
        dropDown.style.opacity = "0";
      })
      e.currentTarget.setAttribute("open", "")
      const dropDown = e.currentTarget.querySelector(".dropdown-menu");
      dropDown.style.opacity = "100";
    }
  });

  ml.addEventListener("blur", e => {
    e.currentTarget.removeAttribute("open")
    const dropDown = e.currentTarget.querySelector(".dropdown-menu");
    dropDown.style.opacity = "0";
  })
})
